import React, { useEffect, useRef } from 'react';
import { VERY_SHORT_BLOOD_GROUPS } from '../../entities';
import styles from './bloodStations.module.scss';

import {
  Button,
  Clusterer,
  FullscreenControl,
  GeolocationControl,
  Map,
  Placemark,
  YMaps,
  ZoomControl,
} from 'react-yandex-maps';


export const Ymaps = (
  {
    bloodStations,
    mobileOpenPopup,
    mapLoaded,
    isMobile,
    mapRef = null,
    mobileMapRef = null,
    placemarkRefs = null,
    mapGeolocationClick,
    boundsMoving,
    mapBounds,
    defaultCity,
    onBoundsChange,
    currentMapBounds
  }) => {

  return (
    <YMaps>
      <Map
        instanceRef={mobileMapRef ? mobileMapRef : mapRef}
        state={{
          // center: [defaultCity?.lat, defaultCity?.lng],
          bounds: mapBounds
        }}
        options={{
          minZoom: 10,
        }}
        // defaultState={{
        //   center: [defaultCity?.lat, defaultCity?.lng],
        //   zoom: 12
        // }}
        onLoad={mapLoaded}
        width={'100%'}
        height={'100%'}
        onBoundsChange={()=>boundsMoving(mobileMapRef ? mobileMapRef : mapRef)}
      >
        <Clusterer
          options={{
            preset: 'islands#invertedRedClusterIcons',
            groupByCoordinates: false,
            zoomMargin: 150,
          }}
        >
          {bloodStations && bloodStations.length > 0 && bloodStations.map((bs, i) => {
            return <Placemark
              key={bs.id}
              instanceRef={(ref) => (placemarkRefs[i] = ref)}
              geometry={[bs.lat, bs.lng]}
              id={bs.id}
              properties={{
                hintContent: bs.title,
                balloonContentHeader: bs.title,
                balloonContentBody: `
                <div>
                  <p>${bs.address}<p>
                  <div class='${styles.Needs}'>
                  ${Object.keys(VERY_SHORT_BLOOD_GROUPS).map((item) => {
                    return `<div class='${bs[item] === 'need' ? styles.need : styles.unknown}'>
                      ${VERY_SHORT_BLOOD_GROUPS[item]}
                    </div>`
                  }).join('')}
                  </div>
                </div>`,
                balloonContentFooter: `<a href="/bloodstations/${bs.id}" class='${styles.BalloonLink}'>Узнать больше</a>`,
                objectId: bs.id
              }}
              modules={
                ['geoObject.addon.balloon', 'geoObject.addon.hint']
              }
              options={{
                iconImageHref: '/static/images/icons/mapIco.svg',
                iconLayout: 'default#image',
                iconImageSize: [32, 32],
                hasBalloon: !isMobile
              }}
              onClick={(e) => {
                if (isMobile)
                  mobileOpenPopup(e.get('target').properties._data)
              }}
            />
          })}
        </Clusterer>
        <GeolocationControl
          onClick={(e) => {
            e.preventDefault()
            mapGeolocationClick()
          }}
          options={{float: 'left'}}/>
        <ZoomControl options={{float: 'left'}}/>
      </Map>
    </YMaps>
  )
}
